






import Vue from 'vue'
import CreateForm from '@/components/polls/CreateForm/CreateForm.vue'
export default Vue.extend({
  components: {
    CreateForm
  }
})
